import { getNotificationsAction } from '@/actions/notifications/get-notifications-action'
import { getNotifiedProductsAction } from '@/actions/notifications/get-notified-products-action'
import { queryOptions } from '@tanstack/react-query'

export const notificationQuery = {
  getNotifications: queryOptions({
    queryKey: ['notifications'],
    queryFn: async () => {
      const res = await getNotificationsAction()

      if (res.type === 'error') {
        throw new Error(res.error)
      }

      const { data, statusCode, message } = res
      const notifiedIds = data.results.map(({ id, product }) => ({
        notificationId: id,
        productId: product.id,
      }))
      return { data: notifiedIds, statusCode, message }
    },
    staleTime: Infinity,
  }),
  getNotifiedProducts: queryOptions({
    queryKey: ['notified', 'products'],
    queryFn: async () => {
      const res = await getNotifiedProductsAction()

      if (res.type === 'error') {
        throw new Error(res.error)
      }

      const { data, statusCode, message } = res
      const notifiedIds = data.products.map(({ id }) => id)
      return { data: notifiedIds, statusCode, message }
    },
  }),
}
